import { ResponseMESF } from "@dexteel/mesf-core";
import { Box, Grid, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import { AgGridFooterActions } from "../../../../../../shared/data-entries/AgGridFooterActions";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTimerContext } from "../../../context/timer.provider";
import { useEAFDataEntryActions } from "../../../hooks/useEAFDataEntryActions";
import { CarbonInjection } from "../../../models/eaf.models";
import { readInjectionsFromPLC } from "../../../repositories/eaf.repositories";
import { InjectionModal } from "../../modals/injections/InjectionModal";
import { useTheme } from "@mui/material/styles";
import { eafDETablesStyles } from "../styles/eafDETablesStyles";
import { useTableData } from "./hooks/useInjectionDataTable";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TableInjection = () => {
  const theme = useTheme();
  const styles = eafDETablesStyles(theme);
  const { pause, resume } = useTimerContext();
  const {
    state: { deProcess },
    actions: { setNotificationMessage, setErrorMessage },
  } = useDataEntryContext();
  const { refreshData } = useEAFDataEntryActions();
  const [showModal, setShowModal] = useState(false);
  const [selectedInjection, setSelectedInjection] = useState<CarbonInjection>();
  const carbonInjections = deProcess?.carbonInjections;

  const readAutomaticInjections = async (value?: string) => {
    if (value === "OK") {
      const resp = await readInjectionsFromPLC({
        ProcessId: deProcess!.process!.ProcessId,
      });
      if (resp.ok) {
        setNotificationMessage("Read injections from PLC successful");
        await refreshData();
        return resp as ResponseMESF;
      } else {
        setErrorMessage(resp.message);
        return {
          ok: false,
          message: "Read injections from PLC failed",
        } as ResponseMESF;
      }
    } else {
      return {} as ResponseMESF;
    }
  };

  const editInjection = (injectionTypeId: number) => {
    pause();
    const injection = carbonInjections?.find(
      (c) => c.InjectionTypeId === injectionTypeId,
    );
    setSelectedInjection(injection);
    setShowModal(true);
  };

  const { columns } = useTableData({ editInjection });

  return (
    <>
      <Paper>
        <Box padding={1} sx={styles.agGridBox}>
          <AgGridReact
            rowData={carbonInjections}
            columnDefs={columns}
            defaultColDef={{ ...defaultColDef, sortable: false }}
            loadingOverlayComponent={CenteredLazyLoading}
            getRowId={(params) =>
              `${(params.data as CarbonInjection).InjectionTypeId}-${
                (params.data as CarbonInjection).IsInjectionManual
              }`
            }
            {...defaultGridOptions}
          />
          <AgGridFooterActions
            hasMaxItems={true}
            readFromPLC={readAutomaticInjections}
            table="injections"
            show={{ new: false, plc: true }}
          />
        </Box>
      </Paper>
      <InjectionModal
        showModal={showModal}
        injection={selectedInjection}
        onHide={() => {
          resume();
          setShowModal(false);
        }}
      />
    </>
  );
};
